// Vue
import { defineStore } from 'pinia';

export const useButtonDisabledStore = defineStore({
  id: 'disabled',
  state: () => ({
    isDisabled: false
  }),
  actions: {
    buttonTemporaryDisabled() {
      this.isDisabled = true;
      // 0.2秒ボタン無効
      setTimeout(() => {
        // ボタン有効化
        this.isDisabled = false;
      }, 200);
    }
  }
});